import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MatDialog } from '@angular/material/dialog';
import { select, Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { UntypedFormControl } from '@angular/forms';
import { ConnectionsSearchComponent } from '../../connections-search-component/connections-search.component';
import { AddConnectionComponent } from '../../add-connection-component/add-connection.component';
import { LoginStoreEffects } from '@app/root-store/login-store/effects';
import * as loginSelectors from '../../../../root-store/login-store/login.selector';
import { AddTrustTemplateDialogComponent } from '../../add-trust-template-dialog/add-trust-template-dialog.component';
import { ManageTemplateTypeComponent } from '../manage-template-type/manage-template-type.component';
import { AddTrustTemplate } from '../../add-trust-template-dialog/add-trust-template.interfaces';
import { NotifyDocumentCreatedAddAsRolePlayers } from '@app/shared/services/notify-document-created-add-as-roleplayers/notify-document-created-add-as-roleplayers';
import { ManageElementFilterConfigurationType } from './manage-element.inteface';
import { ConfigurationType } from './enum';
import { AddEntityDilaogComponent } from '@app/modules/vault/components/dialogs/add-entity-dilaog/add-entity-dilaog.component';
import { NotifyNewVaultCreated } from '@app/shared/services/notify-new-vault-created/notify-new-vault-created';

function Required(target: object, propertyKey: string) {
  Object.defineProperty(target, propertyKey, {
    get() {
      throw new Error(`Attribute ${propertyKey} is required`);
    },
    set(value) {
      Object.defineProperty(target, propertyKey, {
        value,
        writable: true,
        configurable: true,
      });
    },
    configurable: true,
  });
}

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'manage-combo-element',
  templateUrl: './manage-combo-element.component.html',
  styleUrl: './manage-combo-element.component.scss',
  changeDetection: ChangeDetectionStrategy.Default,
})
export class ManageComboElementComponent implements OnInit, OnDestroy {
  @Input() placeHolder = '';
  @Input() filterConfiguration: ManageElementFilterConfigurationType[] = [];
  @Input({ required: true }) @Required hub_vault_user_form_id: string;
  @Input() isInputFullWidth = false;
  @Input() isbalanceSheetOwner = false;
  @Input() inlineComponent = false;
  @Input() set unifiedView(value: boolean) {
    this._unifiedView = value;
    if (value) {
      this.updateMergedData();
    }
  }
  @Output() selectionChange: EventEmitter<any> = new EventEmitter<any>();
  /* 
  filterConfiguration = [{
      label: 'Kinnect User',
      key: ConfigurationType.USERS,
      data: [],
      placeHolder: 'Search Connection',
      selectedData: [],
      templateConfigurationList: [],
    }, {
      label: 'Template',
      key: ConfigurationType.TEMPLATE,
      data: [],
      placeHolder: 'Search Template',
      selectedData: this.nonProfessionalUsers,
      templateConfigurationList: [],
    }, {
      label: 'Contact',
      key: ConfigurationType.TEMPLATE,
      data: [],
      placeHolder: 'Search Contact',
      selectedData: this.nonProfessionalUsers,
      templateConfigurationList: [],
    }]
  */

  USERS = ConfigurationType.USERS;
  TEMPLATE = ConfigurationType.TEMPLATE;
  ATTACHMENTS = ConfigurationType.ATTACHMENTS;
  selectedConfiguration: any = {};
  selectedConfigurationElement;
  isShowConfiguratedTemplate = false;
  isFilterOptionOpen: boolean = false;

  currentUser;
  loadOnce = false;
  isComboInput = true;
  loader: boolean = false;
  @Input() origin = undefined;
  @Input() isShowFooter = true;
  @Input() disableSearch = false;
  @Input() isManageGuardian = false;
  @Input() isShowCreateNewUser = true;
  isInputFocused: boolean = false;
  subscription = new Subscription();
  mergedData: any[] = [];
  private _unifiedView = false;
  templateConfigurationList: any[] = [];
  connectionUserFormControl = new UntypedFormControl();
  @ViewChild(MatAutocompleteTrigger) autocomplete: MatAutocompleteTrigger;
  @ViewChild('inputField', { read: ElementRef }) inputField: ElementRef<HTMLInputElement>;

  constructor(
    private store: Store,
    private dialog: MatDialog,
    private loginService: LoginStoreEffects,
    private _notifyDocumentCreatedAddAsRolePlayers: NotifyDocumentCreatedAddAsRolePlayers,
    private _notifyNewVaultCreated: NotifyNewVaultCreated,
    private cd: ChangeDetectorRef
  ) {
    this.subscription.add(
      this.loginService.loginObject.subscribe((state) => {
        if (state?.data) {
          if (state?.data?.id && !this.loadOnce) {
            this.loadOnce = true;
          }
        }
      })
    );
  }

  ngOnInit(): void {
    this.subscription.add(
      this.store.pipe(select(loginSelectors.getCurrentUserFullDetails)).subscribe((result) => {
        if (result) {
          this.currentUser = result;
        }
      })
    );

    if (this.disableSearch) {
      this.connectionUserFormControl.disable();
    }

    if (this.isManageGuardian) this.isShowFooter = false;
    this.selectedConfigurationElement = this.filterConfiguration[0].label;
    this.selectedConfiguration = this.filterConfiguration[0];
    if (this.unifiedView) {
      this.updateMergedData();
    }
    this.cd.detectChanges();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.selectedConfigurationElement && this.filterConfiguration && this.filterConfiguration.length) {
      const selected = this.filterConfiguration.find((f) => f.label === this.selectedConfigurationElement);
      if (selected) {
        this.selectedConfiguration = JSON.parse(JSON.stringify(selected));
      }
      if (this.unifiedView) {
        this.updateMergedData();
      }
    }
    this.cd.detectChanges();
  }
  get unifiedView(): boolean {
    return this._unifiedView;
  }

  updateMergedData(): void {
    if (!this.unifiedView || !this.filterConfiguration) {
      this.mergedData = [];
      this.templateConfigurationList = [];
      return;
    }

    const allData = [];
    this.templateConfigurationList = [];
    const hasUsersFilterConfig = this.filterConfiguration.some((config) => config.key === ConfigurationType.USERS);
    this.filterConfiguration.forEach((config) => {
      if (config.data && config.data.length) {
        const typedData = config.data.map((item) => ({
          ...item,
          dataType: config.key,
          originalConfig: config,
        }));
        allData.push(...typedData);
      }
      if (config.key === 'template' && config.templateConfigurationList && config.templateConfigurationList.length > 0) {
        this.templateConfigurationList = [...this.templateConfigurationList, ...config.templateConfigurationList];
      }
    });

    if (hasUsersFilterConfig) {
      this.templateConfigurationList = [
        {
          id: 'create-user',
          label: 'Create New User',
          displayType: this.isManageGuardian ? 'Invite User' : 'Create New User',
          img: 'assets/images/footer-new-user.svg',
          isCustomImg: true,
          action: 'create-user',
        },
        ...this.templateConfigurationList,
      ];
    }

    this.mergedData = allData;
  }

  onInputFocus() {
    this.isShowConfiguratedTemplate = true;
    this.isInputFocused = true;
    this.onFocusFromParent();
  }

  onInputBlur() {
    // this.isShowConfiguratedTemplate = false;
    // this.isInputFocused = false;
    // this.inputField.nativeElement.blur();
    // this.cd.detectChanges();
  }

  onClearInput() {
    // this.autocomplete.closePanel();
    this.connectionUserFormControl.setValue('');
    this.cd.detectChanges();
  }

  selectionChangeComboComponent(event) {
    this.selectionChange.emit({ event, selectedConfiguration: event?.originalConfig ? event.originalConfig : this.selectedConfiguration });
  }

  onConfigurationChange(event) {
    this.selectedConfigurationElement = event.tab.textLabel;
    const selected = this.filterConfiguration.find((f) => f.label === event.tab.textLabel);
    if (selected) {
      this.selectedConfiguration = JSON.parse(JSON.stringify(selected));
      this.connectionUserFormControl.setValue('');
    }
    this.cd.detectChanges();
  }

  trackByFn(index: number, item: any): number {
    return item ? item.id : index;
  }

  onFocusFromParent() {
    setTimeout(() => {
      this.inputField.nativeElement.focus();
      this.isInputFocused = true;
    });
  }

  onMemberSearch(value) {
    this.connectionUserFormControl.setValue(value);
    this.cd.detectChanges();
  }

  selectUser(user: any) {
    this.connectionUserFormControl.disable();
    this.selectionChangeComboComponent(user);
    setTimeout(() => {
      this.connectionUserFormControl.enable();
    }, 500);
  }

  setSelectedUsers() {
    this.cd.detectChanges();
    this.cd.markForCheck();
  }

  openInvite1() {
    this.connectionUserFormControl.disable();
    setTimeout(() => {
      this.connectionUserFormControl.enable();
    }, 500);
  }

  openInvite() {
    const modalRef3 = this.dialog.open(AddConnectionComponent, {
      autoFocus: false,
      disableClose: true,
      panelClass: 'full-window-dialog-2',
      data: { fromAddVault: true, fromSharing: true },
    });
    this.subscription.add(
      modalRef3.afterClosed().subscribe((res) => {
        if (res) {
          const itemData = {
            ...res,
            ...(!res.user_id && { user_id: res.id }),
            ...(!res?.connection_status && { connection_status: 'invited' }),
          };
          this.isInputFocused = false;
          this.autocomplete?.closePanel();
          this.selectionChangeComboComponent(itemData);
          this.cd.detectChanges();
        } else {
          this.isInputFocused = false;
          this.autocomplete?.closePanel();
        }
      })
    );
  }

  addExistingUsers() {
    this.isInputFocused = false;
    const addedUser = this.selectedConfiguration.selectedData.map(({ user_id }) => ({ user_id }));
    const dialogRef = this.dialog.open(ConnectionsSearchComponent, {
      panelClass: 'full-window-dialog-2',
      data: {
        title: 'Global User Search',
        placeholderText: 'Search Other Users',
        fromLinkedTemplate: true,
        existingUsers: addedUser,
        requestForAddedUserData: true,
      },
    });
    this.subscription.add(
      dialogRef.afterClosed().subscribe((res) => {
        if (res) {
          this.isInputFocused = false;
          this.autocomplete?.closePanel();
          this.selectionChangeComboComponent(res);
          this.cd.detectChanges();
        } else {
          this.isInputFocused = false;
          this.autocomplete?.closePanel();
        }
      })
    );
  }

  openGlobalSearch() {
    this.connectionUserFormControl.disable();
    setTimeout(() => {
      this.connectionUserFormControl.enable();
    }, 500);
  }

  onTrustSearch(value) {
    this.connectionUserFormControl.setValue(value);
    this.cd.detectChanges();
  }

  selectConnectedUser(user) {
    this.selectionChangeComboComponent(user);
    this.autocomplete.closePanel();
  }

  addNewTemplate(item) {
    this.autocomplete.closePanel();
    // this.inputField.nativeElement.blur();
    if (item?.is_security_key_added) {
      this.selectionChangeComboComponent({
        add_new: true,
      });
    } else {
      if (item.isGroup) {
        if (item.groupList.length == 1) {
          const groupData = {
            id: item.groupList[0].id,
            label: item.groupList[0].type,
            type: item.groupList[0].type,
            hub_vault_user_form_id: this.hub_vault_user_form_id,
          };
          this.openCreateTrustType(groupData);
          return;
        }

        this.openCreateEntityDialog();
        // const dialogRef = this.dialog.open<ManageTemplateTypeComponent>(ManageTemplateTypeComponent, {
        //   data: {
        //     groupList: item.groupList,
        //     title: item.label,
        //   },
        // });

        // this.subscription.add(
        //   dialogRef.afterClosed().subscribe(
        //     (res) => {
        //       this.autocomplete.closePanel();
        //       if (res) {
        //         const groupData = {
        //           id: res.id,
        //           label: res.type,
        //           type: res.type,
        //           hub_vault_user_form_id: this.hub_vault_user_form_id,
        //         };
        //         this.openCreateTrustType(groupData);
        //       }
        //     },
        //     (error) => {}
        //   )
        // );
      } else {
        this.openCreateTrustType(item);
      }
    }
  }

  openCreateTrustType(item) {
    this.autocomplete.closePanel();
    const dialogRef = this.dialog.open<AddTrustTemplateDialogComponent, AddTrustTemplate>(AddTrustTemplateDialogComponent, {
      data: {
        vault_id: undefined,
        inbox_attachment_id: undefined,
        vaultFormId: item.id,
        title: item.label,
        vaultType: item.type,
        hub_vault_user_form_id: this.hub_vault_user_form_id,
        origin: this.origin,
      },
    });
    this.subscription.add(
      dialogRef.afterClosed().subscribe(
        (res) => {
          if (res) {
            this.subscription.add(this._notifyDocumentCreatedAddAsRolePlayers.sendMessage(res));
            setTimeout(() => {
              const itemData = this.selectedConfiguration.data.filter((item) => item.id === res.id);
              this.autocomplete.closePanel();
              this.selectionChangeComboComponent({ ...res, ...itemData[0] });
            }, 2000);
          }
        },
        (error) => {}
      )
    );
  }

  openCreateEntityDialog() {
    const dialogRef = this.dialog.open(AddEntityDilaogComponent, {
      panelClass: 'full-window-dialog',
      autoFocus: false,
      data: {},
    });
    this.subscription.add(
      dialogRef.afterClosed().subscribe((res) => {
        if (res.status && res.data) {
          this.subscription.add(this._notifyDocumentCreatedAddAsRolePlayers.sendMessage(res.data));
          setTimeout(() => {
            const itemData = this.selectedConfiguration.data.filter((item) => item.id === res.data.id);
            this.autocomplete.closePanel();
            if (this.unifiedView) {
              res.data.originalConfig = this.filterConfiguration.find((item) => item.key === 'template');
            }
            this.selectionChangeComboComponent({ ...res.data, ...itemData[0] });
            this._notifyNewVaultCreated.sendMessage(res.data);
          }, 2000);
        }
      })
    );
  }

  selectUnifiedItem(item: any) {
    if (item.dataType === 'users') {
      this.selectUser(item);
    } else if (item.dataType === 'template') {
      this.selectConnectedUser(item);
    }
  }

  forceAutocompletePanelToOpenBelow(): void {
    setTimeout(() => {
      const overlayRef = (this.autocomplete as any)?._overlayRef;
      if (!overlayRef) {
        return;
      }

      const strategy = overlayRef.getConfig()?.positionStrategy as any;
      if (!strategy) {
        return;
      }

      strategy.withPush(false).withPositions([
        { originX: 'start', originY: 'bottom', overlayX: 'start', overlayY: 'top' },
        { originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'top' },
      ]);

      overlayRef.updatePosition();
    });
  }

  handleUnifiedViewFooterAction(action: any): void {
    if (action.action === 'create-user') {
      this.openInvite();
    } else {
      this.addNewTemplate(action);
    }
  }

  onPanelClosed() {
    this.isInputFocused = false;
    this.selectedConfigurationElement = this.filterConfiguration[0].label;
    this.selectedConfiguration = this.filterConfiguration[0];
    this.connectionUserFormControl.setValue('');
    this.cd.detectChanges();
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
}
